/**
 * @generated SignedSource<<0c207fde62157d916141a78557eb3862>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ToggleWatchFeaturedDealMutation$variables = {
  featuredDealNodeId: string;
};
export type ToggleWatchFeaturedDealMutation$data = {
  readonly toggleWatchFeaturedDeal: {
    readonly featuredDeal: {
      readonly watching: boolean | null;
    } | null;
  } | null;
};
export type ToggleWatchFeaturedDealMutation = {
  response: ToggleWatchFeaturedDealMutation$data;
  variables: ToggleWatchFeaturedDealMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "featuredDealNodeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "featuredDealId",
    "variableName": "featuredDealNodeId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "watching",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToggleWatchFeaturedDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleWatchFeaturedDealMutation",
        "kind": "LinkedField",
        "name": "toggleWatchFeaturedDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeaturedDealNode",
            "kind": "LinkedField",
            "name": "featuredDeal",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToggleWatchFeaturedDealMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ToggleWatchFeaturedDealMutation",
        "kind": "LinkedField",
        "name": "toggleWatchFeaturedDeal",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FeaturedDealNode",
            "kind": "LinkedField",
            "name": "featuredDeal",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8ee216a0248c952857a700561666d3cc",
    "id": null,
    "metadata": {},
    "name": "ToggleWatchFeaturedDealMutation",
    "operationKind": "mutation",
    "text": "mutation ToggleWatchFeaturedDealMutation(\n  $featuredDealNodeId: String!\n) {\n  toggleWatchFeaturedDeal(featuredDealId: $featuredDealNodeId) {\n    featuredDeal {\n      watching\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3d714728ccbd7d1c8d017398644f97c";

export default node;
